import { Button, Modal, Para } from 'ui-components';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function ManualPaymentReminder({ open, onClose }: Props): React.ReactElement {
  return (
    <Modal title="Erinnerumg" onClose={onClose} open={open} titleClassName="text-bold text-2xl">
      <Para>Hast du diesen Kunden bereits abgerechnet?</Para>
      <div className="flex justify-center">
        <Button onClick={onClose} className="w-1/2">
          Fertig
        </Button>
      </div>
    </Modal>
  );
}
